export default __webpack_public_path__ + "static/media/H0006.1b091e96.png";